import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';

import InformationCommunityDetail from '@/components/Information/InformationCommunity/InformationCommunityDetail/InformationCommunityDetail';
import DefaultLayout from '@/components/Layout/Layout';
import SocietyGuideDetail from '@/components/Society/SocietyGuideDetail/SocietyGuideDetail';
import Auth from '@/pages/Auth/Auth';
import CompleteFindId from '@/pages/CompleteFindId/CompleteFindId';
import Contact from '@/pages/Contact/Contact';
import FindId from '@/pages/FindId/FindId';
import FindPw from '@/pages/FindPw/FindPw';
import Home from '@/pages/Home/Home';
import Information from '@/pages/Information/Information';
import Introduce from '@/pages/Introduce/Introduce';
import Membership from '@/pages/Membership/Membership';
import ModifyPw from '@/pages/ModifyPw/ModifyPw';
import MyPage from '@/pages/MyPage/MyPage';
import PaymentResult from '@/pages/PaymentResult/PaymentResult';
import Publication from '@/pages/Publication/Publication';
import SignUp from '@/pages/SignUp/SignUp';
import Society from '@/pages/Society/Society';
import SponsorshipDonationDetail from '@/components/Sponsorship/SponsorshipDonationDetail';
import Sponsorship from '@/pages/Sponsorship/Sponsorship';

const router = createBrowserRouter([
	{
		element: <DefaultLayout />,
		children: [
			{ path: '/', element: <Home /> },
			{ path: '/auth/login', element: <Auth /> },
			{ path: '/auth/findid', element: <FindId /> },
			{ path: '/auth/findid/complete', element: <CompleteFindId /> },
			{ path: '/auth/findpw', element: <FindPw /> },
			{ path: '/auth/findpw/modify', element: <ModifyPw /> },
			{ path: '/auth/signup', element: <SignUp /> },
			{ path: '/mypage', element: <MyPage /> },
			{ path: '/introduce', element: <Introduce /> },
			{ path: '/society', element: <Society /> },
			{ path: '/society/guide/:id', element: <SocietyGuideDetail /> },
			{ path: '/membership', element: <Membership /> },
			{ path: '/information', element: <Information /> },
			{ path: '/information/community/:id', element: <InformationCommunityDetail communityBoard /> },
			{ path: '/information/notice/:id', element: <InformationCommunityDetail /> },
			{ path: '/publication', element: <Publication /> },
			{ path: '/payment/result', element: <PaymentResult /> },
			{ path: '/contact', element: <Contact /> },
			{ path: '/sponsorship', element: <Sponsorship /> },
			{ path: '/sponsorship/donation/:id', element: <SponsorshipDonationDetail /> },

			{ path: '*', element: <Navigate to="/" replace /> },
		],
	},
]);

const Router = () => (
	<RouterProvider
		router={router}
		future={{
			v7_startTransition: true,
		}}
	/>
);

export default Router;
